import type { ReactElement } from "react";

export function ForwardArrowIcon(): ReactElement {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="scale(-1,1) translate(-24,0)">
        <path
          d="M7.42047 12.85L13.1627 18.5923L11.9742 19.8L4.19922 12.025L12.0242 4.20001L13.2127 5.40776L7.42047 11.2H19.7992V12.85H7.42047Z"
          fill="#16181D"
        />
      </g>
    </svg>
  );
}
